/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payments_Filter_One_TimeInputs */

const fr_payments_filter_one_time = /** @type {(inputs: Payments_Filter_One_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiements uniques`)
};

/**

* @param {Payments_Filter_One_TimeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const payments_filter_one_time = /** @type {((inputs?: Payments_Filter_One_TimeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payments_Filter_One_TimeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_payments_filter_one_time(inputs)
});